export const ColorSwatch14Items = [
    '#6AE2FD',
    '#0B873A',
    '#11CF59',
    '#FFA640',
    '#FFED94',
    '#CB3C7E',
    '#EB757F',
    '#8D79F2',
    '#BFB2FF',
    '#33CC99',
    '#6CF0C3',
    '#FFEF40',
    '#FFFFDB',
    '#F7A1CC'
];

export const ActivationsColorPalette = [
    '#2D74DA',
    ...ColorSwatch14Items,
    '#1254B8',
    ...ColorSwatch14Items
];
